// extracted by mini-css-extract-plugin
module.exports = {"label":"ApplicationQuestionsFormSection_label__3v-uA","helperText":"ApplicationQuestionsFormSection_helperText__1yO72","disabled":"ApplicationQuestionsFormSection_disabled__vwxbB"};